module.exports = __webpack_public_path__ + "img/organization-block-user.276a7ca0.svg";